export default Object.freeze({
  'social': "Dodatkowo wnoszę o objęcie mnie dobrowolnym ubezpieczeniem społecznym",
  'medical': "Dodatkowo wnoszę o objęcie mnie dobrowolnym ubezpieczeniem chorobowym"
})
